import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import BoardsLoader from "./BoardsLoader";
import registerServiceWorker from "./registerServiceWorker";

ReactDOM.render(<BoardsLoader />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js